(() => {
  "use strict";
  if (!window.Lymko || window.__lk_routine) return;
  window.__lk_routine = 1;
  const { $, $$, reduced, esc, money, toast, addItems, openO, closeAll, reveal, markFavs, store, R, CFG } = window.Lymko;
  function routineFinder() {
    const el = $("[data-quiz]");
    const dataEl = $("#quizdata");
    if (!el || !dataEl) return;
    const D = JSON.parse(dataEl.textContent);
    const T = D.t || {};
    const tr = (s, o) => String(s || "").replace(/\[(\w+)\]/g, (m, k) => k in o ? o[k] : m);
    const card = (h) => {
      const t = $(`#quizcards template[data-card="${h}"]`);
      return t ? t.innerHTML : "";
    };
    const Q = [
      [D.q[0], D.skins.map((s) => [s.key, s.label, s.hint, s.img])],
      [D.q[1], D.concerns.map((c) => [c.key, c.label, c.hint, c.img])],
      [D.q[2], D.sizes.map((z) => [z.key, z.label, z.hint, z.img])]
    ].filter((q) => q[1].length);
    let A = [];
    const arrow = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    const draw = (k) => {
      if (k >= Q.length) return result();
      const q = Q[k];
      el.innerHTML = `<div class="qprog" role="progressbar" aria-valuemin="0" aria-valuemax="${Q.length}" aria-valuenow="${k}"><i style="width:${k / Q.length * 100}%"></i></div><div class="qq"><span class="lab o">${esc(tr(T.qof, { n: k + 1, total: Q.length }))}</span><h1 class="h2">${esc(q[0])}</h1>
        <div class="qopts">${q[1].map((o) => `<button type="button" data-qa="${esc(o[0])}" class="${A[k] === o[0] ? "on" : ""}">${o[3] ? `<img class="qimg" src="${esc(o[3])}" alt="" width="56" height="56" loading="lazy">` : ""}<div>${esc(o[1])}${o[2] ? `<span>${esc(o[2])}</span>` : ""}</div>${arrow}</button>`).join("")}</div>
        <div class="qnav">${k ? `<button type="button" class="link" data-qb>${esc(T.back)}</button>` : "<span></span>"}<span style="font-size:13px;color:var(--muted)">${esc(T.time)}</span></div></div>`;
      $$("[data-qa]", el).forEach((b) => b.addEventListener("click", () => {
        A[k] = b.dataset.qa;
        b.classList.add("on");
        setTimeout(() => draw(k + 1), reduced ? 0 : 250);
      }));
      const bk = $("[data-qb]", el);
      if (bk) bk.addEventListener("click", () => draw(k - 1));
      scrollTo(0, 0);
      const f = $("[data-qa]", el);
      if (f) f.focus({ preventScroll: true });
    };
    const result = () => {
      const [type, con, pref0] = A;
      const pref = pref0 || "min";
      store.set("lk_routine", { a: A, d: Date.now() });
      const c = D.concerns.find((x) => x.key === con) || D.concerns[0];
      if (!c) {
        el.innerHTML = "";
        return;
      }
      const sk = D.skins.find((x) => x.key === type) || { label: type || "", tip: "" };
      const b = D.base;
      const AM = [...new Set([b.cleanser, c.am, b.moisturizer, b.sunscreen].filter(Boolean))];
      const PM = [...new Set([b.cleanser, c.pm || c.am, c.extra, b.moisturizer].filter(Boolean))];
      const set = pref === "min" ? AM : [.../* @__PURE__ */ new Set([...AM, ...PM])];
      const P = D.products;
      const tot = set.reduce((s, h) => s + (P[h] ? P[h].price : 0), 0), mrp = set.reduce((s, h) => s + (P[h] ? P[h].compare : 0), 0);
      const nt = set.filter((h) => P[h] && !(P[h].suitable || []).filter(Boolean).length).map((h) => P[h].title);
      const rit = (D.rituals || []).filter((r) => r.items && r.items.length > 1 && r.items.every((i) => set.includes(i))).sort((x, y) => y.items.length - x.items.length)[0];
      el.innerHTML = `<div class="qprog"><i style="width:100%"></i></div><div class="qq"><span class="lab o">${esc(tr(T.eyebrow, { skin: sk.label, concern: c.label }))}</span><h1 class="h2">${T.heading || ""}</h1><p class="p">${esc(sk.tip || "")} ${esc(c.spf_extra ? String(T.spf || "").replace(/\.\s*$/, "") + c.spf_extra + "." : T.spf || "")}</p>
        ${nt.length && T.note ? `<p class="hl-note" style="margin-top:10px">${esc(tr(T.note, { products: nt.join(", ") }))}</p>` : ""}
        <div style="margin-top:40px"><span class="lab">${esc(pref === "min" ? T.yours : T.am)}</span><div class="res-steps">${AM.map(card).join("")}</div></div>
        ${pref === "min" ? "" : `<div><span class="lab">${esc(T.pm)}</span><div class="res-steps">${PM.map(card).join("")}</div></div>`}
        ${rit && T.save ? `<div class="cbreak" style="margin-top:10px">${tr(esc(T.save), { ritual: `<a class="link" href="${esc(rit.url)}">${esc(rit.title)}</a>`, n: rit.items.length, price: money(rit.price) })}</div>` : ""}
        <div class="sum" style="position:relative;top:0;margin-top:20px"><div class="row"><span>${esc(tr(T.count, { n: set.length }))}</span><span style="color:var(--muted);text-decoration:line-through">${money(mrp)}</span></div><div class="row tot"><span>${esc(T.total)}</span><span>${money(tot)}</span></div>
        <button type="button" class="btn btn-o" id="qall">${esc(T.add)} <span class="ar">→</span></button><button type="button" class="link" id="qre" style="display:table;margin:16px auto 0">${esc(T.again)}</button></div></div>`;
      $("#qall").addEventListener("click", async () => {
        try {
          const add = set.filter((h) => P[h] && P[h].available !== false);
          if (!add.length) {
            toast(T.soldout);
            return;
          }
          await addItems(add.map((h) => ({ id: P[h].id, quantity: 1 })));
          openO("cart");
        } catch (e) {
          toast(e.message);
        }
      });
      $("#qre").addEventListener("click", () => {
        store.set("lk_routine", null);
        A = [];
        draw(0);
      });
      reveal(el);
      markFavs();
      scrollTo(0, 0);
    };
    const saved = store.get("lk_routine", null);
    const valid = saved && saved.a && saved.a.length === Q.length && Q.every((q, i) => q[1].some((o) => o[0] === saved.a[i]));
    if (valid) {
      A = saved.a;
      result();
    } else draw(0);
  }
  const init = () => {
    routineFinder();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
